import axios from 'axios';
import { SYSTEMDOX_API_URL } from '@/lib/apiConfig';

const api = axios.create({ baseURL: SYSTEMDOX_API_URL });

export type TechCategory = 'language' | 'framework' | 'infrastructure' | 'testing' | 'cicd' | 'database' | 'other';

export interface TechStackEntry {
  id: string;
  name: string;
  version?: string;
  category: TechCategory;
  notes?: string;
  createdAt: string;
}

export const TECH_CATEGORIES: { value: TechCategory; label: string }[] = [
  { value: 'language', label: 'Language' },
  { value: 'framework', label: 'Framework' },
  { value: 'infrastructure', label: 'Infrastructure' },
  { value: 'database', label: 'Database' },
  { value: 'testing', label: 'Testing' },
  { value: 'cicd', label: 'CI/CD' },
  { value: 'other', label: 'Other' },
];

export const techStackApi = {
  setAuthProvider(getToken: () => Promise<string | null>) {
    api.interceptors.request.use(async (config) => {
      const token = await getToken();
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    });
  },

  async list(): Promise<TechStackEntry[]> {
    const { data } = await api.get('/ai/settings/stack');
    return data;
  },

  async add(entry: Omit<TechStackEntry, 'id' | 'createdAt'>): Promise<TechStackEntry> {
    const { data } = await api.post('/ai/settings/stack', entry);
    return data;
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/ai/settings/stack/${id}`);
  },
};
